var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6276 2.0247C6.22292 1.67804 2.37123 4.96771 2.02457 9.37236C1.67792 13.777 4.96758 17.6287 9.37224 17.9754C13.7769 18.322 17.6286 15.0324 17.9752 10.6277C17.9976 10.3442 18.0038 10.0397 17.9948 9.73856C17.9824 9.32453 17.6367 8.99896 17.2227 9.01137C16.8086 9.02378 16.4831 9.36947 16.4955 9.7835C16.5029 10.0321 16.4978 10.2826 16.4799 10.51C16.1982 14.0888 13.0687 16.7617 9.48993 16.48C5.91114 16.1983 3.23829 13.0688 3.51995 9.49005C3.8016 5.91127 6.93111 3.23842 10.5099 3.52008C12.2462 3.65672 13.8156 4.47053 14.9222 5.75475L15.1258 6.00263L12.747 6.0035L12.6452 6.01035C12.2791 6.06001 11.997 6.37381 11.997 6.7535C11.997 7.1332 12.2791 7.44699 12.6452 7.49666L12.747 7.5035H16.7469L16.8487 7.49666C17.1815 7.45151 17.4449 7.18807 17.4901 6.85527L17.4969 6.7535V2.7535L17.4901 2.65173C17.4449 2.31894 17.1815 2.0555 16.8487 2.01035L16.7469 2.0035L16.6451 2.01035C16.3124 2.0555 16.0489 2.31894 16.0038 2.65173L15.9969 2.7535L15.9981 4.70625C14.6402 3.16635 12.7322 2.19034 10.6276 2.0247Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.2c36a03750e67669c18387a43c0c7b83.svg";
export { ForwardRef as ReactComponent };